<div class="criteria-steps">
    <div class="criteria-steps-marker">
        <div class="criteria-steps-marker-txt">{{ stepDescription }}</div>
        <div class="criteria-steps-marker-dot">
            <i class="criteria-steps-marker-dot-icn criteria-steps-marker-dot-icn-active theme-check"></i>
            <i class="criteria-steps-marker-dot-icn criteria-steps-marker-dot-icn-locked theme-locked-i"></i>
        </div>
    </div>

    <div class="criteria-steps-slider">
        <div [ngStyle]="{ width: stepPercentage + '%' }" class="criteria-steps-slider-progress"></div>
        <div
            [ngStyle]="{ left: stepPercentage + '%' }"
            [style.background-image]="'url(' + stepImage?.src + ')'"
            class="criteria-steps-slider-thumb"></div>
    </div>
</div>
